export default __webpack_public_path__ + "static/media/marazzi_840x660.8cc08fcb.jpg";